export interface GalleryPhoto {
  id: number;
  name: string | null;
  icon: string | null;
  grid: string | null;
  thumb: string | null;
  photo: string;
  width: number;
  height: number;
}
export interface GalleryAlbum {
  id: number;
  url: string;
  name: string;
  short_description: string | null;
  description?: string | null;
  photos_count: number;
  cover: GalleryPhoto | null;
  updated_at: string;
}
export interface GalleryPagination {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}
export interface GalleryAlbumPage {
  album: GalleryAlbum;
  photos: GalleryPhoto[];
  meta: GalleryPagination;
}

export function galleryImageSrcset(image: GalleryPhoto): string | undefined {
  if (!image.width) return undefined;
  const sources = new Map<number, string>();
  for (const [url, width] of [[image.grid, 400], [image.thumb, 800], [image.photo, 2400]] as const) {
    if (url) sources.set(Math.min(image.width, width), url);
  }
  return [...sources].map(([width, url]) => `${url} ${width}w`).join(', ') || undefined;
}
